import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Services from './components/pages/Services';
import ServiceDetail from './components/pages/ServiceDetail';
import Privacy from './components/pages/Privacy';
import CookiePolicy from './components/pages/CookiePolicy';
import Blog from './components/pages/Blog';
import BlogDetail from './components/pages/BlogDetail';
import AuditLanding from './components/pages/AuditLanding';
import AuditResults from './components/pages/AuditResults';
import AuditThankYou from './components/pages/AuditThankYou';
import NotFound from './components/pages/NotFound';
import Home from './components/pages/Home'; // Create this component for the homepage

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/blog/category/:category" element={<Blog />} />
      <Route path="/blog/tag/:tag" element={<Blog />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/free-ai-audit" element={<AuditLanding />} />
      <Route path="/audit-results" element={<AuditResults />} />
      <Route path="/audit-results/thank-you" element={<AuditThankYou />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;